import {
  InteractionRequiredAuthError,
  type AccountInfo,
} from '@azure/msal-browser';
import {
  createE2ECustomerAccount,
  isE2EWithoutSso,
} from '@e2e/e2eAuth';
import { loginRequest, silentRequest } from './msal';
import { msalInstance } from './msalInstance';

interface CustomerAuthSession {
  getAccount: () => AccountInfo | undefined;
  getAccessToken: () => Promise<string | null>;
}

const createE2EAuthSession = (): CustomerAuthSession => {
  const account = createE2ECustomerAccount();

  return {
    getAccount: () => account,
    getAccessToken: async () => account.idToken,
  };
};

const getMsalAccount = (): AccountInfo | undefined =>
  msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

const createMsalAuthSession = (): CustomerAuthSession => ({
  getAccount: getMsalAccount,
  getAccessToken: async () => {
    const account = getMsalAccount();
    if (!account) return null;

    try {
      const response = await msalInstance.acquireTokenSilent({
        ...silentRequest,
        account,
      });
      return response.idToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        const response = await msalInstance.acquireTokenPopup({
          ...loginRequest,
        });
        return response.idToken;
      }

      console.error(error);
      return null;
    }
  },
});

export const customerAuthSession = isE2EWithoutSso
  ? createE2EAuthSession()
  : createMsalAuthSession();
